'use strict';

var Layer = require('./Layer');

class OutputLayer extends Layer {
    constructor(options) {
        super(options);

        this.activationFunction = function (i, j) {
            this[i][j] = Math.exp(this[i][j]);
        };
    }

    static load(model) {
        if (model.model !== 'Layer') {
            throw new RangeError('the current model is not a Layer model');
        }

        return new OutputLayer(model);
    }
}

module.exports = OutputLayer;



// WEBPACK FOOTER //
// ./node_modules/ml-fnn/src/OutputLayer.js